import React from "react"
import { asCurrency, formatDate, humanizeLabel } from "../../services/Utils"
import { useSwipeable } from "react-swipeable"
import { AddToCart } from "./AddToCart"
import { AddToCartV2 } from "./AddToCartV2"
import { ProductUnitPrice } from "./ProductUnitPrice"

function SwipeableImage({ onSwipeLeft, onSwipeRight, children }) {
  const handlers = useSwipeable({
    onSwipedLeft: onSwipeLeft,
    onSwipedRight: onSwipeRight
  })
  return <div { ...handlers }>{ children }</div>
}

export class ProductGallery extends React.Component {
  componentDidMount() {
    window.addEventListener("keydown", this.handleKeyPress.bind(this))
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyPress.bind(this))
  }

  handleKeyPress(event) {
    const key = event.keyCode

    if (!this.props.visible) return

    if (key == 39)
      // right
      this.next()
    else if (key == 37)
      // left
      this.previous()
    else if (key == 27)
      // esc
      this.props.closeGallery()
  }

  next() {
    this.props.changeGalleryIndex(this.props.index + 1)
  }

  previous() {
    this.props.changeGalleryIndex(this.props.index - 1 )
  }

  render() {
    if (!this.props.visible || !this.props.product_unit) { return (<div />) }

    return (
      <div id="modal-mask" onClick={ this.props.closeGallery }>
        <div className="modal-popout" onClick={ (event) => { event.stopPropagation() } }>
          <div>
            <div className="text-center px-5 py-1 cursor-pointer" onClick={ this.props.closeGallery }>
              <i className="fa fa-lg fa-times" aria-hidden="true" />
            </div>
          </div>
          {this.renderDisplay()}
        </div>
      </div>
    )
  }

  renderIndividualUnitPrice(product_unit) {
    if ( !this.props.showPricing || !product_unit.individual_unit_name) { return }
    if ( product_unit.individual_unit_price == product_unit.final_price ) { return }
    return (
      <div className='mt-2'>
        <span className='tabular-nums'>{ asCurrency(product_unit.individual_unit_price) }</span> / { product_unit.individual_unit_name }
      </div>
    )
  }

  renderShortSaleBadge(product_unit) {
    if (!product_unit.is_short_sale) { return }

    const labelType = humanizeLabel(product_unit.date_label_type)

    return (
      <div className="mt-1">
        <span className="badge badge-dark">
          Short Sale: { labelType } { formatDate(product_unit.short_sale_date_label_on) }
        </span>
      </div>
    )
  }

  renderProductUnits(other_product_units) {
    const AddToCartComponent = this.props.anyDateAvailability ? AddToCartV2 : AddToCart


    const otherUnits = other_product_units.map( (product_unit) => {
      if ( product_unit.id == this.props.product_unit.id ) { return }
       return (
        <div className='py-2 border-top' key={ product_unit.product_unit_id }>
          <div className='product-unit'>{ product_unit.unit }</div>
          { this.renderShortSaleBadge(product_unit) }
          <div><ProductUnitPrice product_unit={ product_unit } showPricing={ this.props.showPricing }/></div>
          <div className='row'>
            <div className="col-lg-6">
              <AddToCartComponent
                product_name={ product_unit.name }
                product_unit={ product_unit }
                show_unit={ true }
                requestedOn={ this.props.requestedOn }
                showAvailability={ this.props.showAvailability }
                src='gallery_other_units'
                colorClass='border-dark'
                seller_id={ product_unit.seller_id }
                showPricing={ this.props.showPricing }
                cartEnabled={ this.props.cartEnabled }
                addItem={ this.props.addItem }/>
            </div>
          </div>
        </div>
      )
    })
    if (otherUnits.filter(Boolean).length) {
      return (
        <div className='border-top mt-3'>
          <div className='mt-3 h5 font-weight-bold'>OTHER UNITS</div>
          { otherUnits }
        </div>
      )
    }
  }

  renderDisplay() {
    const product_unit = this.props.product_unit
    const rightarrow = (
      <div className="col-md-2 py-5 col-1 align-self-center text-right cursor-pointer" onClick={this.next.bind(this)}>
        <i className="fa fa-2x fa-chevron-right" aria-hidden="true" />
      </div>
    )

    const leftarrow = (
      <div className="col-md-2 py-5 col-1 align-self-center text-left cursor-pointer" onClick={this.previous.bind(this)}>
        <i className="fa fa-2x fa-chevron-left" aria-hidden="true" />
      </div>
    )

    let city_state_tag
    if (product_unit.city && product_unit.state) {
      city_state_tag = (
        <div className="producer-city-state">
          {product_unit.city}, {product_unit.state}
        </div>
      )
    }

    const AddToCartComponent = this.props.anyDateAvailability ? AddToCartV2 : AddToCart

    var image = (product_unit.product_photo || {}).large_url
    return (
      <div id="product-overlay">
        <div className='row no-gutters'>
          { leftarrow }
          <div className='col-md-8 col-10 mb-2 text-center'>
            <SwipeableImage onSwipeLeft={ this.next.bind(this) } onSwipeRight={ this.previous.bind(this) }>
              <img className='img-fluid image-placeholder' src={image} />
            </SwipeableImage>
          </div>
          { rightarrow }
        </div>
        <div className="row no-gutters justify-content-center">
          <div className='col-md-8 col-10 mb-4'>
            <div className='producer-details mb-2'>
              <div className="product-producer">
                {product_unit.producer_name}
              </div>
              <div>{ city_state_tag }</div>
            </div>
            <div className="product-name">
              { product_unit.name }
            </div>
            <div className='product-unit'>
              { product_unit.unit }
            </div>
            <div className='h5 mt-2'>
                <ProductUnitPrice product_unit={ product_unit } showPricing={ this.props.showPricing } />
              </div>
            { this.renderIndividualUnitPrice(product_unit) }
            <div className="product-description">
              { product_unit.description}
            </div>
            <div className='row'>
              <div className="col-lg-6">
                <AddToCartComponent
                  product_unit={ product_unit }
                  requestedOn={ this.props.requestedOn }
                  showAvailability={ this.props.showAvailability }
                  seller_id={ product_unit.seller_id }
                  showPricing={ this.props.showPricing }
                  cartEnabled={ this.props.cartEnabled }
                  addItem={ this.props.addItem }
                  src='catalog_gallery'
                />
              </div>
            </div>
            <div className="product-prices grid">
              { this.renderProductUnits(product_unit.otherProducts || []) }
            </div>
          </div>
        </div>
      </div>
    )
  }
}
